/* eslint-disable max-len */
import env from '../config/env';
import ApiService from './ApiService';

const getCompany = (companyId) => ApiService.httpClient.get(`${env.api.url}/v0/companies/company/${companyId}`)
  .then((response) => response.data);

const findCompany = (taxCountryCode, taxNo) => ApiService.httpClient.get(`${env.api.url}/v0/companies/find`, {
  params: {
    taxCountryCode,
    taxNo,
  },
});

const CompanyService = {
  getCompany,
  findCompany,
};

export default CompanyService;
